import axios from '../axios';
// 字段对照表列表
export const getSysComparePage = data => {
  return axios({
    url: '/api/sys/compare/getSysComparePage',
    method: 'post',
    data
  })
};
// 字段对照表明细列表
export const getSysCompareFieldPage = data => {
  return axios({
    url: '/api/sys/compare/getSysCompareFieldPage',
    method: 'post',
    data
  })
};
// 字段对照表明细列表
export const queryTheSystemTableFieldsByTableName = data => {
  return axios({
    url: '/api/sys/compare/queryTheSystemTableFieldsByTableName',
    method: 'post',
    data
  })
};
// 字段对照表保存
export const saveSysCompare = data => {
  return axios({
    url: '/api/sys/compare/saveSysCompare',
    method: 'post',
    data
  })
};
// 字段对照表修改
export const updateSysCompare = data => {
  return axios({
    url: '/api/sys/compare/updateSysCompare',
    method: 'post',
    data
  })
};
// 字段对照表删除
export const deleteSysCompares = data => {
  return axios({
    url: '/api/sys/compare/deleteSysCompares',
    method: 'post',
    data
  })
};
// 开启/关闭对照策略
export const enableSysCompares = data => {
  return axios({
    url: '/api/sys/compare/enableSysCompares',
    method: 'post',
    data
  })
};
// 删除审批流配置表
export const deleteActProcessConfigs = data => {
  return axios({
    url: '/api/sys/act/process/config/deleteActProcessConfigs',
    method: 'post',
    data
  })
};
// 查询单条审批流配置表
export const getActProcessConfig = data => {
  return axios({
    url: '/api/sys/act/process/config/getActProcessConfig',
    method: 'post',
    data
  })
};
// 审批流配置表列表
export const getActProcessConfigPage = data => {
  return axios({
    url: '/api/sys/act/process/config/getActProcessConfigPage',
    method: 'post',
    data
  })
};
// 审批流配置表合计行
export const getActProcessConfigSum = data => {
  return axios({
    url: '/api/sys/act/process/config/getActProcessConfigSum',
    method: 'post',
    data
  })
};
// 保存审批流配置表
export const saveActProcessConfig = data => {
  return axios({
    url: '/api/sys/act/process/config/saveActProcessConfig',
    method: 'post',
    data
  })
};
// 审批流配置表状态
export const statusActProcessConfigs = data => {
  return axios({
    url: '/api/sys/act/process/config/statusActProcessConfigs',
    method: 'post',
    data
  })
};
// 修改审批流配置表
export const updateActProcessConfig = data => {
  return axios({
    url: '/api/sys/act/process/config/updateActProcessConfig',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/ThirdPartyInterface.js